/**
 * A tile that goes somewhere: a page in the app, or another site in a new tab. Title, a line on what's there, and a
 * mono hint of where it leads. The Pitch overview is a grid of these.
 */
import type { ReactNode } from 'react'
import { Link } from '../nav'
import { Icon, type IconName } from '../primitives/Icon'
import s from './LinkTile.module.css'

export function LinkTile({ title, children, to, href, icon, meta }: { title: string; children: ReactNode; /** A path in this app. */ to?: string; /** Another site: opens in a new tab. */ href?: string; icon?: IconName; /** Where it leads, in mono: "cpg.computer/privacy". */ meta?: string }) {
  const body = (
    <>
      <span className={s.head}>
        {icon && <Icon name={icon} />}
        <span className={s.title}>{title}</span>
        {href && <Icon name="out" size="sm" label="Opens in a new tab" />}
      </span>
      <span className={s.body}>{children}</span>
      {meta && <span className={s.meta}>{meta}</span>}
    </>
  )
  return to ? (
    <Link to={to} aria-label={title}>
      <span className={s.tile}>{body}</span>
    </Link>
  ) : (
    <a className={s.tile} href={href} target="_blank" rel="noreferrer">
      {body}
    </a>
  )
}
